import { defineStore } from 'pinia';

export interface WorkspaceOption {
  value: string;
  label: string;
  color: string | null;
}

export const useWorkspaceSwitcherPopupStore = defineStore('workspace-switcher-popup', {
  state: () => ({
    visible: false,
    from: null as WorkspaceOption | null,
    to: null as WorkspaceOption | null,
  }),
  actions: {
    open(from: WorkspaceOption, to: WorkspaceOption) {
      this.from = from;
      this.to = to;
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.from = null;
      this.to = null;
    },
  },
});
